import type { Route } from "./+types/home";
import Welcome from "@/pages/welcome";

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Nettpay" },
    { name: "description", content: "Welcome to Nettpay!" },
  ];
}

export default function Home() {
  return <Welcome />;
}
